export const STATUS_MAP = {
  incomplete: {
    label: "Incomplete",
    value: "incomplete",
  },
  submitted_for_review: {
    label: "Submitted for Review",
    value: "submitted_for_review",
  },
  input_required: {
    label: "Input Required",
    value: "input_required",
  },
  completed: {
    label: "Completed",
    value: "completed",
  },
  rejected: {
    label: "Rejected",
    value: "rejected",
  },
  connected: {
    label: "Connected",
    value: "connected",
  },
  under_review: {
    label: "Under Review",
    value: "under_review",
  },
  verified: {
    label: "Verified",
    value: "verified",
  },
  pending: {
    label: "Pending",
    value: "pending",
  },
  awaiting_confirmation: {
    label: "Awaiting Confirmation",
    value: "awaiting_confirmation",
  },
  signed: {
    label: "Signed",
    value: "signed",
  },
  approved: {
    label: "Approved",
    value: "approved",
  },
  partial: {
    label: "Partially Signed", 
    value: "partial" 
  },
  initiated: {
    label: "Initiated", 
    value: "initiated" 
  },
  failed: {
    label: "Failed", 
    value: "failed" 
  }
};

export const businessKycBusinessSegment = [
  {
    label: "Manufacturing",
    value: "manufacturing",
  },
  {
    label: "Services",
    value: "services",
  },
  {
    label: "Trading",
    value: "trading",
  },
];

export const platformList = [
  { value: "amazon", label: "Amazon" },
  { value: "noon", label: "Noon" },
  { value: "talabaat", label: "Talabaat" },
  { value: "own", label: "Own website/D2C" },
  { value: "other", label: "Other" },
];

export const financingList = [
  { value: "invoice", label: "Invoice Discounting" },
  { value: "revenue", label: "Revenue Based Financing" },
  { value: "working_capital", label: "Working Capital Loan" },
];

export const EVERSIGN_SIGNING_SCRIPT = 'https://static.eversign.com/js/embedded-signing.js';